import React from 'react';
import Content from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './problem.module.scss';
import OmgSvg from '@/svgs/handwriting/omg';
import OnayamiSvg from '@/svgs/handwriting/onayami';
import ArrowSvg from '@/svgs/handwriting/arrow';

const ProblemContent: React.FC = () => {
  return (
    <>
      <h2>
        こんな<strong>課題</strong>、<br className="sp" />
        ありませんか？
      </h2>
      <ul className={styles.oProblem__list}>
        <li>
          <dl>
            <dt>予算</dt>
            <dd>プロトタイプの開発っていくらかかるの？</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>定義</dt>
            <dd>プロトタイプってそもそも何の役に立つの？</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>期間</dt>
            <dd>依頼してからどれぐらいで、何ができるの？</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>具現</dt>
            <dd>アイデアを形にするにはどうしたらいいの？</dd>
          </dl>
        </li>
      </ul>
      <dl className={styles.oProblem__decorationCharactor}>
        <dt>
          <OmgSvg />
        </dt>
        <dd>
          <StaticImage src="./img/omg.png" alt="こんな課題、ありませんか？" />
        </dd>
      </dl>
      <dl className={styles.oProblem__decorationOnayami}>
        <dt>
          <OnayamiSvg />
        </dt>
        <dd>
          <ArrowSvg />
        </dd>
      </dl>
    </>
  );
};

const Problem: React.FC<{ setScroll: Function }> = ({ setScroll }) => {
  return (
    <Content
      className={{ wrapper: styles.oProblem, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby, callback: setScroll }}
    >
      <ProblemContent />
    </Content>
  );
};

export default Problem;
